<template>
  <div class="container">
    <div ref="threeCanvas" class="three-canvas"></div>
    <div class="info-box" v-if="selectedObjectInfo">
      
      {{ selectedObjectInfo }}
      <div v-if="fetchedComponent">
        <label>ID: <input v-model="fetchedComponent.id" /></label><br>
        <label>类型: <input v-model="fetchedComponent.type" /></label><br>
        <label>应变: <input v-model="fetchedComponent.strain" /></label><br>
        <button @click="updateInfo">更新信息</button>
      </div>
    </div>
    <div class="button-container">
      <button @click="resetModel" class="reset-button">重置模型</button>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import axios from 'axios';
//import { response } from 'express';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';

export default {
  name: 'ThreeJSComponent',
  data() {
    return {
      scene: null,
      camera: null,
      renderer: null,
      model: null,
      raycaster: new THREE.Raycaster(),
      mouse: new THREE.Vector2(),
      controls: null,
      lod: null,
      initialPosition: new THREE.Vector3(),
      initialRotation: new THREE.Quaternion(),
      selectedObject: null,
      selectedObjectInfo: '', // 保存选中对象的信息
      fetchedComponent: null,  // 新增变量，用于存储从数据库获取的数据
    };
  },
  methods: {
    initThree() {
      // 初始化场景
      this.scene = new THREE.Scene();

      // 添加环境光
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
      this.scene.add(ambientLight);

      // 添加方向光
      const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
      directionalLight.position.set(5, 10, 7.5);
      this.scene.add(directionalLight);

      // 初始化相机
      this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
      this.camera.position.set(0, 300, 0); // 摄像机置于模型正上方
      this.camera.lookAt(new THREE.Vector3(0, 0, 0)); // 改变摄像头角度

      // 初始化渲染器
      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      this.renderer.outputEncoding = THREE.sRGBEncoding;
      this.$refs.threeCanvas.appendChild(this.renderer.domElement);

      // 设置Three.js画布背景色
      this.renderer.setClearColor(new THREE.Color(0x87ceeb)); // 天蓝色背景

      // 初始化轨道控制器
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = true;
      this.controls.dampingFactor = 0.25;
      this.controls.enableZoom = true;

      // 初始化 LOD 对象
      this.lod = new THREE.LOD();
      this.scene.add(this.lod);

      // 加载模型
      this.loadModels();
    },
    async loadModels() {
      const loader = new GLTFLoader();
      const dracoLoader = new DRACOLoader();
      
      // 设置 DracoLoader 解压路径，通常指向 `node_modules/three/examples/js/libs/draco/`
      dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
      loader.setDRACOLoader(dracoLoader);

      // 加载高分辨率模型
      const highRes = await loader.loadAsync('models/SH.glb');
      //this.addUserData(highRes.scene, '高分辨率', 0.01); // 添加自定义数据
      this.lod.addLevel(highRes.scene, 10); // 距离 0 使用高分辨率模型

      // 加载中分辨率模型
      //const mediumRes = await loader.loadAsync('models/car__animation.glb');
      //this.addUserData(mediumRes.scene, 'bridge_1'); // 添加自定义数据
      //this.lod.addLevel(mediumRes.scene, 100); // 距离 50 使用中分辨率模型

      // 加载低分辨率模型
      //const lowRes = await loader.loadAsync('models/bridge.gltf');
      //lowRes.scene.rotation.y = Math.PI / 2; // 将低分辨率模型旋转 90 度
      //this.addUserData(lowRes.scene, '低分辨率', 0.03); // 添加自定义数据
      //this.lod.addLevel(lowRes.scene, 200); // 距离 100 使用低分辨率模型

      // 设置 LOD 的位置
      this.lod.position.set(0, 0, 0);

      // 保存模型的初始位置和旋转
      this.initialPosition.copy(this.lod.position);
      this.initialRotation.copy(this.lod.quaternion);

      // 开始动画循环
      this.animate();
    },
    addUserData(scene, modelId) {
  scene.traverse((node) => {
    if (node.isMesh) {
      // 如果 mesh 对象有名称，则使用其名称作为 id，否则生成随机 id
      const componentId = node.name || `Component-${Math.random().toString(36).substr(2, 9)}`;

      // 为每个 mesh 设置 userData，包含 modelId 和 componentId
      node.userData = {
        modelId: modelId,  // 传递的模型 ID
        id: componentId,   // 生成的或已有的构件 ID
        //type: 'Unknown',   // 这里也可以根据需要传递构件类型
        //strain: '0.0000',  // 默认为 0.0000 或传递自定义值
      };

      // 调试输出，确保为每个构件正确分配了 userData
      console.log(`Component Added: modelId=${modelId}, componentId=${componentId}`);
    }
  });
}
,
    animate() {
      requestAnimationFrame(this.animate);

      this.controls.update();
      this.lod.update(this.camera); // 更新 LOD 模型
      this.renderer.render(this.scene, this.camera);
    },
    onMouseClick(event) {
      const rect = this.$refs.threeCanvas.getBoundingClientRect();
      this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

      this.raycaster.setFromCamera(this.mouse, this.camera);
      const intersects = this.raycaster.intersectObjects(this.scene.children, true);

      if (intersects.length > 0) {
        const intersectedObject = intersects[0].object;

        if (this.selectedObject && this.selectedObject.material) {
          this.selectedObject.material.emissive.setHex(this.selectedObject.currentHex || 0x000000);
        }

        this.selectedObject = intersectedObject;

        if (this.selectedObject && this.selectedObject.material) {
          this.selectedObject.currentHex = this.selectedObject.material.emissive.getHex();
          this.selectedObject.material.emissive.setHex(0xff0000); // 高亮显示
        }

        // 清空之前的显示内容和数据库结果
        this.selectedObjectInfo = '';
        this.fetchedComponent = null;

        if (this.selectedObject && this.selectedObject.userData) {
          const { modelId, id } = this.selectedObject.userData;

          console.log('Model ID:', modelId);
          console.log('Component ID:', id);

          // 查询数据库中的数据
          axios.get(`http://localhost:27071/api/bridge_tunnel_group/${modelId}`)
            .then(({ data }) => {
              const component = data.components.find(c => c.id === id);
              if (component) {
                this.fetchedComponent = component;  // 将数据库中的结果赋值给 fetchedComponent
                this.selectedObjectInfo = `Component ID: ${component.id}, Type: ${component.type}, Strain: ${component.strain}`;
              } else {
                this.selectedObjectInfo = '未找到匹配的构件信息';
              }
            })
            .catch((error) => {
              console.error('Error fetching model data:', error);
              this.selectedObjectInfo = '无法获取模型数据';
            });
        }
      } else {
        if (this.selectedObject && this.selectedObject.material) {
          this.selectedObject.material.emissive.setHex(this.selectedObject.currentHex || 0x000000);
        }
        this.selectedObjectInfo = ''; // 清空显示信息
        this.fetchedComponent = null;  // 清空数据库中的结果
  }
},
    updateInfo() {
      if (this.selectedObject) {
        const { id, type, strain } = this.selectedObject.userData;
        this.selectedObjectInfo = `ID: ${id}, Type: ${type}, Strain: ${strain}`;
        axios.post('http://localhost:5000/object',{
          id,
          type,
          strain,
        })
        .then(() => {
          this.selectedObjectInfo = 'ID: ${id}, Type: ${type}, Strain: ${strain} 已保存到数据库';
        });
      }
    },
    resetModel() {
      if (this.model) {
        this.model.position.copy(this.initialPosition);
        this.model.quaternion.copy(this.initialRotation);
        this.selectedObjectInfo = ''; // 清空信息
        if (this.selectedObject && this.selectedObject.material && this.selectedObject.material.emissive) {
          this.selectedObject.material.emissive.setHex(this.selectedObject.currentHex);
          this.selectedObject = null;
        }
        this.renderScene();
      }
    },
    renderScene() {
      this.renderer.render(this.scene, this.camera);
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
    this.$refs.threeCanvas.removeEventListener('click', this.onMouseClick);
  },
  mounted() {
    this.initThree();
    window.addEventListener('resize', this.onWindowResize, false);
    this.$refs.threeCanvas.addEventListener('click', this.onMouseClick, false);
  },
};
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.three-canvas {
  width: 100%;
  height: 100%;
}

.button-container {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}

.reset-button {
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  background: linear-gradient(45deg, #6ab7ff, #4f83cc);
  color: white;
  border: none;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.reset-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
}

.info-box {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #333;
}
</style>
